import axiosInstance from "../../../api/axiosConfig";
import { VerifyOtpFormValues } from "./verify-otp-page.type";

export const verifyOtp = (data: VerifyOtpFormValues) => {
  return axiosInstance.post("/auth/verify-otp", data);
};
